import { useBranding } from '~/helpers/branding/branding'
import { cn } from '~/lib/utils'

type BrandLogoProps = {
  /** Classe appliquée à l'image du logo. */
  className?: string
  /** Classe appliquée au fallback texte (nom de l'app) si aucun logo. */
  fallbackClassName?: string
}

/**
 * Affiche le logo configuré (white-label) ou, à défaut, le nom de l'app en
 * texte. Remplace toute référence à un logo client codé en dur.
 */
export function BrandLogo({ className, fallbackClassName }: BrandLogoProps) {
  const { logo, appName } = useBranding()

  if (logo) {
    return <img src={logo} alt={appName} className={className} />
  }

  return (
    <span className={cn('font-heading font-semibold tracking-tight', fallbackClassName)}>
      {appName}
    </span>
  )
}
